import Carousel from './components/Carousel'
import Media from './components/Media'

const MediaCarousel = {
  Carousel,
  Media,
}

export default MediaCarousel
